import React from 'react';
import styled from 'styled-components';
import { FormTitle } from '../customComponents/FormTitle';
import { useLang } from '../context/LangContext';
import CustomTiptapEditor from './Editor/CustomTiptapEditor';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`;

const Content = styled.div`
  padding: 16px 0;
`;

// 에디터 컨테이너 (읽기 전용 모드용)
const EditorContainer = styled.div`
  background-color: #f3f6f6;
  border-radius: 12px;
  overflow: hidden;
  
  .editor-container {
    height: auto !important;
    min-height: auto !important;
    border-radius: 12px;
    overflow: hidden;
  }
  
  .tiptap-editor-content {
    height: auto !important;
    min-height: auto !important;
    overflow: visible;
    border-radius: 12px;
  }
  
  .tiptap-editor-content .ProseMirror {
    padding: 16px;
    font-size: 14px;
    color: #333;
    line-height: 1.6;
    text-align: left;
    background: transparent;
    border: none;
    outline: none;
    border-radius: 12px;
  }
  
  /* .tiptap-editor-content .ProseMirror:focus {
    outline: none;
  } */
  
  
  .tiptap-editor-content .ProseMirror img {
    border-radius: 8px;
    max-width: 100%;
    height: auto;
  }
`;



interface LotDescriptionProps {
  title?: string;
  description?: string;
  isVisible?: boolean;
}

// 다국어 텍스트
const lotDescriptionTexts = {
  ko: { title: 'LOT 설명' },
  en: { title: 'LOT Description' }
};

const LotDescription: React.FC<LotDescriptionProps> = ({ 
  title,
  description,
}) => {
  const { lang } = useLang();
  const texts = lotDescriptionTexts[lang];
  
  const sectionTitle = title || texts.title;
  const rawDescription = description || '';

  // description이 비어있으면 컴포넌트를 렌더링하지 않음
  if (!rawDescription || rawDescription.trim() === '') {
    return null;
  }

  return (
    <Container>
      <FormTitle>{sectionTitle}</FormTitle>
      <Content>
        <EditorContainer>
          <CustomTiptapEditor
            content={rawDescription}
            readOnly={true}
            showMenuBar={false}
            enableImageUpload={false}
            height="auto"
            hideBorder={true}
          />
        </EditorContainer>
      </Content>
    </Container>
  );
};

export default LotDescription;
